export default function Configure($stateProvider) {
    $stateProvider.state('societes-transporteur', {
        parent: 'common',
        url: '/societes-transporteur',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('societes-transporteur.list', {
        url: '/list',
        template: '<societes></societes>',
        rights: { domain: 'societes', right: 'read', application: 'gestion' },
        params: {
            genre: '16'
        },
        ncyBreadcrumb: {
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETES_TRANSPORTEUR_LIST" | translate}}'
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETES_TRANSPORTEUR_LIST'
    });

    $stateProvider.state('societes-transporteur.niveaux', {
        url: '/niveaux',
        template: '<societe-config-niveaux></societe-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        params: {
            genre: '16'
        },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher societes > niveaux
            parent: 'societes-transporteur.list({genre: "16"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('societes-transporteur.list.detail', {
        url: '/{id}',
        template: '<societe-detail></societe-detail>',
        rights: { domain: 'societes', right: 'read' },
        params: {
            genre: '16'
        },
        ncyBreadcrumb: {
            parent: 'societes-transporteur.list({genre: "16"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('societes-transporteur.new', {
        url: '/new',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'create' },
        params: {
            genre: '16'
        },
        ncyBreadcrumb: {
            parent: 'societes-transporteur.list({genre: "16"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_TRANSPORTEUR_NEW" | translate}}'
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETE_TRANSPORTEUR_NEW'
    });

    $stateProvider.state('societes-transporteur.edit', {
        url: '/{id}/edit',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'update' },
        params: {
            genre: '16'
        },
        ncyBreadcrumb: {
            parent: 'societes-transporteur.list({genre: "16"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_TRANSPORTEUR_EDIT" | translate }}'
        }
    });

    $stateProvider.state('societes-transporteur.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: {
            parentState: 'societes-transporteur.new',
            genre: '16'
        },
        ncyBreadcrumb: {
            parent: 'societes-transporteur.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
